import { ActivityItemType } from "@app/courses/models/activity-item-type";

export class DownloadResult {
    hasBeenProcessed : boolean;
    isDownloaded :boolean;
    constructor (public uri: string, public moduleId: number, 
        public type?: ActivityItemType, public sectionId?: number, public version?:string, public size?:number, public accessToken?:string){
            
        }
}